import React from 'react';
import cn from "classnames";
import styles from '../../lib/global.css';
import {Link} from 'react-router-dom';
import LoginEntry from "../../../components/menu-bar/login-entry";

/**
 * 导航栏
 * @returns {*}
 * @constructor
 */
const TeacherNavBar = ()=>(
        <div className={cn(styles.antPageHeader, styles.antPageHeaderGhost)} style={{paddingLeft: 0, paddingRight: 0}}>
            <div className={styles.antPageHeaderHeading}>
                <div className={styles.antPageHeaderHeadingLeft}>
                    <Link className={styles.antPageHeaderHeadingTitle} title="首页" to="/">首页</Link>
                    <Link className={styles.antPageHeaderHeadingTitle} to="/teacher">老师首页</Link>
                    <Link className={styles.antPageHeaderHeadingTitle} to="/teacher/courses">课程管理</Link>
                    <Link className={styles.antPageHeaderHeadingTitle} to="/teacher/course">课程管理详情</Link>
                    <Link className={styles.antPageHeaderHeadingTitle} to="/teacher/classes">班级管理</Link>
                    <Link className={styles.antPageHeaderHeadingTitle} to="/teacher/class">班级管理详情</Link>

                </div>
                <div className={styles.antPageHeaderHeadingExtra}>
                    <LoginEntry/>
                </div>
            </div>
        </div>
);


export default  TeacherNavBar;
